<template>
  <loading-spinner> </loading-spinner>
</template>

<script>
export default {
  name: "Slack",
  created() {
    let self = this;
    let code = self.$route.query.code;
    if (code) {
      this.$store
        .dispatch("integration/setSlackToken", code)
        .then(() => {
          self.$router.push({ path: "/" });
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your slack info."
          );
        });
    } else {
      this.$router.push({ path: "/" });
    }
  }
};
</script>
